import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Image } from "@/components/ui/image";
import { Eye, Briefcase, HeartHandshake, Minus } from "lucide-react";

const VAN_IMG = "https://media.base44.com/images/public/6a80a7f0e10008ea488688fc/0fe77d317_generated_561efe07.png";
const icons = [
  { icon: Eye, label: "DISCREET" },
  { icon: Briefcase, label: "PROFESSIONAL" },
  { icon: HeartHandshake, label: "RESPECTFUL" },
  { icon: Minus, label: "MINIMAL DISRUPTION" }
];

export default function Discreet() {
  return (
    <section className="border-b border-border bg-background px-5 py-0 lg:px-8">
      <div className="mx-auto grid max-w-7xl items-stretch lg:grid-cols-2">
        <div className="flex flex-col justify-center py-24 lg:py-32">
          <SectionHeader
            kicker="Discreet Service"
            title="THEY DON'T NEED TO KNOW."
            subtitle="Bed bugs are stressful enough. Our service is professional, respectful and discreet, because the last thing you need is unnecessary attention from neighbours, guests or other residents."
          />
          <div className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-border bg-border sm:grid-cols-4">
            {icons.map((ic, i) => (
              <Reveal key={ic.label} delay={i * 0.06}>
                <div className="flex h-full flex-col items-center justify-center gap-3 bg-background px-4 py-8 text-center">
                  <ic.icon className="h-6 w-6 text-accent" />
                  <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-foreground">{ic.label}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal delay={0.1}>
          <div className="relative h-72 overflow-hidden lg:h-full lg:min-h-[600px]">
            <Image src={VAN_IMG} alt="Unmarked discreet service vehicle on a Vancouver street" fittingType="fill" className="absolute inset-0 h-full w-full" />
            <div className="absolute inset-0 bg-gradient-to-r from-background/40 to-transparent lg:from-background/10" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}